import {
  JOB_ACTIONS,
  JOB_QUEUED,
  JOB_STATUSES,
  JOB_UPDATED,
} from 'containers/App/Header/JobManagement/constants';
import { all, call } from 'redux-saga/effects';

import { setMaintenanceVisibility } from 'components/GlobalState/commands/setMaintenanceVisibility';
import { unsafeGlobalStateDispatch } from 'components/GlobalState/globalStateDispatch';
import { takeEvery } from 'containers/ErrorBoundary';
import { requestCustomErrorMessage } from 'utils/request/requestCustomErrorMessage';

function* jobUpdatedSaga(action) {
  try {
    const jobs = action.payload;
    const maintenanceStarted = jobs.some(
      (job) =>
        [JOB_ACTIONS.maintenance, JOB_ACTIONS.cleanDb].includes(job.action) &&
        job.status === JOB_STATUSES.running,
    );
    if (maintenanceStarted) {
      unsafeGlobalStateDispatch(setMaintenanceVisibility, { value: true });
    }

    const maintenanceDone = jobs.some(
      (job) =>
        [JOB_ACTIONS.maintenance, JOB_ACTIONS.cleanDb].includes(job.action) &&
        job.status === JOB_STATUSES.done,
    );
    if (maintenanceDone) {
      unsafeGlobalStateDispatch(setMaintenanceVisibility, { value: false });
    }
  } catch (e) {
    yield call(requestCustomErrorMessage, 'danger', e);
    throw e;
  }
}

export function* defaultSaga() {
  yield all([
    takeEvery(JOB_UPDATED, jobUpdatedSaga),
    takeEvery(JOB_QUEUED, jobUpdatedSaga),
  ]);
}

export default defaultSaga;
